import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { request, requireConfirmation } from './common.js';

export async function inboxCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'list';
  switch (action) {
    case 'list':
      return request(args, Methods.Inbox);
    case 'delete': {
      const id = Number(args.positionals[2]);
      if (!Number.isInteger(id) || id <= 0)
        throw new CliError('inbox delete requires positive <id>', ExitCode.Usage);
      return request(args, Methods.InboxDelete, { id });
    }
    case 'clear':
      requireConfirmation(args, 'Clearing the inbox requires confirmation');
      return request(args, Methods.InboxClear);
    default:
      throw new CliError(`Unknown inbox action "${action}"`, ExitCode.Usage);
  }
}
